/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Walkthrough_Brain_TitleInputs */

const es_walkthrough_brain_title = /** @type {(inputs: Walkthrough_Brain_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extra Razonamiento`)
};

const en_walkthrough_brain_title = /** @type {(inputs: Walkthrough_Brain_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extra Reasoning`)
};

/**
* | output |
* | --- |
* | "Extra Reasoning" |
*
* @param {Walkthrough_Brain_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const walkthrough_brain_title = /** @type {((inputs?: Walkthrough_Brain_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Walkthrough_Brain_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_walkthrough_brain_title(inputs)
	return en_walkthrough_brain_title(inputs)
});
export { walkthrough_brain_title as "walkthrough.brain_title" }